import {Component, Input, OnInit} from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {SfoUiJSONSchema7} from '../../../../metadata.model';
import { MatFormField, MatLabel, MatHint, MatError } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { NgIf } from '@angular/common';

@Component({
    selector: 'sfo-number-input',
    templateUrl: './number-input.component.html',
    imports: [MatFormField, MatLabel, MatInput, FormsModule, ReactiveFormsModule, NgIf, MatHint, MatError]
})
export class NumberInputComponent implements OnInit {
  @Input() schema!: SfoUiJSONSchema7;
  @Input() aFormControl!: FormControl;
  @Input() defaultValue: unknown;

  ngOnInit(): void {
    const currentValue = this.aFormControl.value;

    if (currentValue === null || currentValue === undefined) {
      const defaultValue = this.defaultValue ?? this.schema?.default;
      if (defaultValue !== undefined) {
        this.aFormControl.setValue(defaultValue, {emitEvent: false});
      }
    }
  }
}
